/* eslint-disable react/display-name */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../components/Header'
import useStore from '../../hooks/useStore'
import { api, uploadTypewidthImage } from '../../services/api'
import { TableColumn, TableStyles } from 'react-data-table-component'
import * as S from './styles'
import Button from '../../components/Button'
import { GiftlistTypesType } from '../../typings/giftlistType'
import { toast } from 'react-toastify'
import Table from '../../components/Table'
import TableHeader from '../../components/TableHeader'
import { Modal } from '../../components/Modal'
import Input from '../../components/Input'

const customStyles: TableStyles = {
  header: {
    style: {
      minHeight: '56px',
      borderRadius: '8px 8px 0 0',
    },
  },
  rows: {
    style: {
      borderBottom: '1px solid rgba(0, 0, 0, .12)',
      borderRight: '1px solid rgba(0, 0, 0, .12)',
      borderLeft: '1px solid rgba(0, 0, 0, .12)',
      padding: '16px 32px',
    },
  },
}

const Types: React.FC = () => {
  const store = useStore()
  const [types, setTypes] = useState<GiftlistTypesType[]>()
  const [isLoading, setIsLoading] = useState(false)
  const [reqTrigger, setReqTrigger] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalIsOpenEdit, setModalIsOpenEdit] = useState(false)
  const [listType, setListType] = useState<GiftlistTypesType>()
  const [selectedImage, setSelectedImage] = useState<File>()
  const [imageLoadError, setImageLoadError] = useState(false)
  const refCreate = useRef<HTMLInputElement>(null)
  const refEdit = useRef<HTMLInputElement>(null)
  const imageUrl = selectedImage ? URL.createObjectURL(selectedImage) : null
  const removeType = async (id: string) => {
    try {
      await api.delete(`/store/giftlist/types/${id}`)
      setReqTrigger(!reqTrigger)
    } catch (err) {
      console.log(err)
      toast.error('Houve um erro ao excluir o tipo de lista')
    }
  }
  const changeImageType = async (id: string) => {
    try {
      const listDetails = await api.get(`/store/giftlist/types/${id}`)
      
      // Detectar URL inválida com hash bcrypt
      if (listDetails.data.thumbnail && listDetails.data.thumbnail.includes('$2b$')) {
        setImageLoadError(false)
      } else {
        setImageLoadError(true)
      }
      
      setListType(listDetails.data)
    } catch (err) {
      console.log(err)
      toast.error('Houve um erro ao carregar os detalhes!')
    }
  }

  const columns: TableColumn<GiftlistTypesType>[] = useMemo(() => {
    return [
      {
        name: 'Nome e ID',
        cell: (row) => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <span style={{ fontWeight: 'bold' }}>{row.type}</span>
            <span style={{ fontSize: '12px', color: '#666' }}>ID: {row.id}</span>
          </div>
        ),
      },
      {
        name: 'Ações',
        cell: (row) => (
          <>
            <Button
              buttonStyle={'danger'}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <g clipPath="url(#clip0_146_3963)">
                    <path d="M2 4.5H3.33333H14" fill="#F33520" />
                    <path
                      d="M2 4.5H3.33333H14"
                      stroke="#F33520"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.33337 4.49992V3.16659C5.33337 2.81296 5.47385 2.47382 5.7239 2.22378C5.97395 1.97373 6.31309 1.83325 6.66671 1.83325H9.33337C9.687 1.83325 10.0261 1.97373 10.2762 2.22378C10.5262 2.47382 10.6667 2.81296 10.6667 3.16659V4.49992M12.6667 4.49992V13.8333C12.6667 14.1869 12.5262 14.526 12.2762 14.7761C12.0261 15.0261 11.687 15.1666 11.3334 15.1666H4.66671C4.31309 15.1666 3.97395 15.0261 3.7239 14.7761C3.47385 14.526 3.33337 14.1869 3.33337 13.8333V4.49992H12.6667Z"
                      stroke="#F33520"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.33337 7.83325V11.8333"
                      stroke="#F33520"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.66663 7.83325V11.8333"
                      stroke="#F33520"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_146_3963">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              }
              style={{ fontSize: '14px', width: 'max-content', padding: 0 }}
              text="Deletar tipo"
              onClick={() => removeType(row.id)}
            />

            <S.StyledButton
              buttonStyle="primary"
              text="Editar"
              onClick={async () => {
                setSelectedImage(undefined)
                setImageLoadError(false)
                await changeImageType(row.id)
                setModalIsOpenEdit(true)
              }}
            />
          </>
        ),

        allowOverflow: true,
        button: true,
        width: 'max-content',
      },
    ]
  }, [types])

  useEffect(() => {
    api
      .get<GiftlistTypesType[]>(`/store/giftlist/types`)
      .then((res) => setTypes(res.data))
      .catch(() => toast.error('Erro ao buscar os tipos de lista'))
  }, [reqTrigger])

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      // Validar tipo de arquivo
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
      if (!validTypes.includes(file.type)) {
        toast.error('Por favor, selecione uma imagem válida (JPEG, PNG, GIF ou WebP)')
        return
      }

      // Validar tamanho (máximo 5MB)
      const maxSize = 5 * 1024 * 1024 // 5MB
      if (file.size > maxSize) {
        toast.error('A imagem deve ter no máximo 5MB')
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        setSelectedImage(file)
        setImageLoadError(false)
      }
      reader.readAsDataURL(file)
    }
  }

  const createType = async () => {
    setIsLoading(true)
    const typeValue = refCreate.current?.value?.trim()

    if (!typeValue) {
      toast.error('Digite o tipo da lista')
      setIsLoading(false)
      return
    }

    try {
      if (selectedImage) {
        await uploadTypewidthImage(typeValue, selectedImage)
      } else {
        await api.post('/store/giftlist/types', { type: typeValue })
      }

      setModalIsOpen(false)
      setReqTrigger(!reqTrigger)
      toast.success('Tipo de lista criado com sucesso!')
      if (refCreate.current) refCreate.current.value = ''
    } catch (err) {
      console.error(err)
      toast.error('Erro ao criar tipo de lista')
    } finally {
      setIsLoading(false)
      imageUrl && URL.revokeObjectURL(imageUrl)
      setSelectedImage(undefined)
    }
  }

  const editType = async () => {
    setIsLoading(true)
    const typeValue = refEdit.current?.value?.trim()

    if (!typeValue) {
      toast.error('Digite o tipo da lista')
      setIsLoading(false)
      return
    }

    try {
      if (selectedImage) {
        // Se tem nova imagem, envia FormData com imagem
        const formData = new FormData()
        formData.append('type', typeValue)
        formData.append('thumbnail', selectedImage)

        await api.put(`/store/giftlist/types/${listType?.id}`, formData, {
          headers: {
            'Content-Type': undefined,
          },
        })
      } else {
        // Se não tem nova imagem, envia apenas o texto
        await api.put(`/store/giftlist/types/${listType?.id}`, {
          type: typeValue,
        })
      }

      setModalIsOpenEdit(false)
      setReqTrigger(!reqTrigger)
      toast.success('Tipo de lista editado com sucesso!')
      if (refEdit.current) refEdit.current.value = ''
    } catch (err) {
      console.error(err)
      toast.error('Erro ao editar tipo de lista')
    } finally {
      setIsLoading(false)
      imageUrl && URL.revokeObjectURL(imageUrl)
      setSelectedImage(undefined)
    }
  }

  return (
    <>
      <Header storeName={store?.vtex_account_name ?? 'Loja'} />
      <S.Wrapper>
        <TableHeader
          createButtonText="Criar tipo"
          title="Tipos de lista"
          onClick={() => {
            setModalIsOpen(true)
            setSelectedImage(undefined)
            if (refCreate.current) refCreate.current.value = ''
          }}
        />
        {types && (
          <Table
            fixedHeader={true}
            customStyles={customStyles}
            columns={columns}
            data={types}
          />
        )}
      </S.Wrapper>
      <Modal
        modalIsOpen={modalIsOpen}
        confirmModalFunction={() => createType()}
        toggleModalFunction={() => {
          setModalIsOpen(false)
          setSelectedImage(undefined)
          if (refCreate.current) refCreate.current.value = ''
        }}
        confirmationText="Salvar"
        title="Criar tipo de lista"
        confirmButtonIsLoading={isLoading}
      >
        <div style={{ maxWidth: '500px', margin: 'auto', width: '100%' }}>
          <Input
            ref={refCreate}
            type="text"
            labelFor="Tipo"
            labelText="Digite o nome"
            placeholder="Lista de casamento"
          />
          <S.StyledImageUpload>
            <input
              type="file"
              accept="image/*"
              id="imageInputCreate"
              onChange={handleImageChange}
            />
            <label htmlFor="imageInputCreate">Selecionar imagem</label>
            {imageUrl && <img src={imageUrl} alt="Selected" />}
            <S.ImageDisclaimer>
              dimensão recomendada da imagem 318x159px
            </S.ImageDisclaimer>
          </S.StyledImageUpload>
        </div>
      </Modal>
      <Modal
        modalIsOpen={modalIsOpenEdit}
        confirmModalFunction={() => editType()}
        toggleModalFunction={() => {
          setModalIsOpenEdit(false)
          setSelectedImage(undefined)
          setImageLoadError(false)
          if (refEdit.current) refEdit.current.value = ''
        }}
        confirmationText="Salvar"
        title="Editar tipo de lista"
        confirmButtonIsLoading={isLoading}
      >
        <div
          style={{
            maxWidth: '500px',
            margin: 'auto',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <Input
            key={listType?.id} 
            ref={refEdit}
            type="text"
            labelFor="TipoEdit"
            labelText="Digite o nome"
            placeholder="Ex: Lista de casamento"
            defaultValue={listType?.type || ''}
          />
          <S.StyledImageUpload>
            <input
              type="file"
              accept="image/*"
              id="imageInputEdit"
              onChange={handleImageChange}
            />
            <label htmlFor="imageInputEdit">Selecionar imagem</label>
            {/* Mostrar nova imagem selecionada */}
            {imageUrl && (
              <div style={{ textAlign: 'center' }}>
                <img src={imageUrl} alt="Nova imagem" />
                <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                  Nova imagem selecionada
                </p>
              </div>
            )}
            {/* Mostrar imagem atual se não houver nova selecionada */}
            {!imageUrl && listType?.thumbnail && !imageLoadError && (
              <div style={{ textAlign: 'center' }}>
                <img 
                  src={listType.thumbnail} 
                  alt="Imagem atual"
                  style={{ maxWidth: '100%', display: 'block', margin: '18px auto 0' }}
                  onError={() => {
                    setImageLoadError(true)
                  }}
                />
                <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                  Imagem atual
                </p>
              </div>
            )}
            {/* Mostrar erro de carregamento */}
            {!imageUrl && imageLoadError && (
              <p style={{ 
                fontSize: '12px', 
                color: '#f44336', 
                marginTop: '8px', 
                background: '#ffebee', 
                padding: '8px', 
                borderRadius: '4px' ,
                marginBottom: '16px'
              }}>
                ⚠️ Imagem anterior com erro. Por favor, envie uma nova imagem.
              </p>
            )}
            {/* Debug: mostrar se não há imagem */}
            {!imageUrl && !listType?.thumbnail && (
              <p style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>
                Nenhuma imagem cadastrada
              </p>
            )}
            <S.ImageDisclaimer>
              dimensão recomendada da imagem 318x159px
            </S.ImageDisclaimer>
          </S.StyledImageUpload>
        </div>
      </Modal>
    </>
  )
}

export default Types
